import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Section} from '../../model/resource-model';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {v4 as uuidv4} from 'uuid';
import { ResourcesHubService } from '../../core/resources-hub.service';

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.css']
})
export class AddSectionComponent implements OnInit, OnChanges, OnDestroy {


  @Input() currentFormIndex: number;
  @Input() sectionData: Section = {}
  @Input() totalSectionCount: number;
  @Output() deleteSectionEmitter: EventEmitter<number> = new EventEmitter();
  @Output() moveSectionUpEventEmitter: EventEmitter<number> = new EventEmitter();
  @Output() moveSectionDownEventEmitter: EventEmitter<number> = new EventEmitter();
  @Output() sectionValueChangeEmitter: EventEmitter<any> = new EventEmitter<any>();
  sectionForm: FormGroup = new FormGroup({
      title: new FormControl('', [])
    }
  );
  isMenuOpen: boolean = false;
  layoutType = {
    1: '100',
    2: '1/2 1/2',
    3: '1/3 1/3 1/3',
    4: '1/3 2/3',
    5: '2/3 1/3'
  }

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(private resourceService:ResourcesHubService){}

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.sectionData).length > 0) {
      this.sectionForm.patchValue({...this.sectionData}, {emitEvent: false})
    }
  }

  ngOnInit(): void {
    this.sectionForm.valueChanges.pipe(debounceTime(1000), takeUntil(this.onDestroy)).subscribe(sectionValues => {
      let updatedSection = JSON.parse(JSON.stringify(this.sectionData));
      this.resourceService.setLastUpdatedId(updatedSection?.uuid)
      updatedSection = {...updatedSection, title: sectionValues.title}
      this.sectionValueChangeEmitter.emit(updatedSection)
    })
  }

  toggleMenu(layoutType?: string, contentBlockIndex?: number) {
    if (layoutType === this.layoutType['2'] || layoutType === this.layoutType['4'] || layoutType === this.layoutType['5']) {
      let updatedContentBlock = JSON.parse(JSON.stringify(this.sectionData.content[contentBlockIndex]));
      if (updatedContentBlock.layout.length > 2) {
        updatedContentBlock.layout.splice(2);
      } else if (updatedContentBlock.layout.length < 2) {
        const newContentBlock = {
          width: 0,
          contentType: '',
          uuid: uuidv4()
        }
        updatedContentBlock.layout.push(newContentBlock);
      }
      if (layoutType === this.layoutType['2']) {
        updatedContentBlock.layout[0].width = 50;
        updatedContentBlock.layout[1].width = 50;
      } else if (layoutType === this.layoutType['4']) {
        updatedContentBlock.layout[0].width = 30;
        updatedContentBlock.layout[1].width = 70;
      } else if (layoutType === this.layoutType['5']) {
        updatedContentBlock.layout[0].width = 70;
        updatedContentBlock.layout[1].width = 30;
      }
      let updatedSection = JSON.parse(JSON.stringify(this.sectionData))
      updatedSection.content[contentBlockIndex] = updatedContentBlock;
      this.sectionValueChangeEmitter.emit(updatedSection);
    }

    if (layoutType === this.layoutType['1']) {
      let updatedContentBlock = JSON.parse(JSON.stringify(this.sectionData.content[contentBlockIndex]));
      if (updatedContentBlock.layout.length > 1) {
        updatedContentBlock.layout.splice(1);
      }
      updatedContentBlock.layout[0].width = 100;
      let updatedSection = JSON.parse(JSON.stringify(this.sectionData))
      updatedSection.content[contentBlockIndex] = updatedContentBlock;
      this.sectionValueChangeEmitter.emit(updatedSection);
      //this.sectionData = updatedSection;
    } else if (layoutType === this.layoutType['3']) {
      let updatedContentBlock = JSON.parse(JSON.stringify(this.sectionData.content[contentBlockIndex]));
      if (updatedContentBlock.layout.length === 1) {
        const firstContentBlock = {
          width: 0,
          contentType: '',
          uuid: uuidv4()
        }
        const secondContentBlock = {
          width: 0,
          contentType: '',
          uuid: uuidv4()
        }
        updatedContentBlock.layout.push(firstContentBlock);
        updatedContentBlock.layout.push(secondContentBlock);
      } else if (updatedContentBlock.layout.length === 2) {
        const firstContentBlock = {
          width: 0,
          contentType: '',
          uuid: uuidv4()
        }
        updatedContentBlock.layout.push(firstContentBlock);
      }
      updatedContentBlock.layout[0].width = 33;
      updatedContentBlock.layout[1].width = 33;
      updatedContentBlock.layout[2].width = 33;
      let updatedSection = JSON.parse(JSON.stringify(this.sectionData))
      updatedSection.content[contentBlockIndex] = updatedContentBlock;
      this.sectionValueChangeEmitter.emit(updatedSection);
    }
    this.isMenuOpen = !this.isMenuOpen;
  }


  addContentBlock() {
    const contentBlockUuid = uuidv4()
    const newContentBlock = {
      width: 100,
      contentType: '',
      uuid: contentBlockUuid
    }
    const updatedSection = JSON.parse(JSON.stringify(this.sectionData));
    updatedSection.content.push({uuid: uuidv4(), layout: [newContentBlock]});
    this.resourceService.setLastUpdatedId(contentBlockUuid)
    this.sectionValueChangeEmitter.emit(updatedSection);

  }

  deleteSection() {
    this.deleteSectionEmitter.emit(this.currentFormIndex)
  }

  moveSectionElementUp() {
    if (this.currentFormIndex > 0) {
      this.moveSectionUpEventEmitter.emit(this.currentFormIndex)
    }
  }

  moveSectionElementDown() {
    if (this.currentFormIndex + 1 < this.totalSectionCount) {
      this.moveSectionDownEventEmitter.emit(this.currentFormIndex)
    }
  }

  moveContentElementUp(index: number) {
    if (index > 0) {
      const updatedSection = JSON.parse(JSON.stringify(this.sectionData));
      this.changeContentElementSequence(updatedSection, index, index - 1);
    }
  }

  moveContentElementDown(index: number) {
    if (index + 1 < this.sectionData.content.length) {
      const updatedSection = JSON.parse(JSON.stringify(this.sectionData));
      this.changeContentElementSequence(updatedSection, index, index + 1);
    }
  }

  deleteContentElement(index: number) {
    const updatedSection = JSON.parse(JSON.stringify(this.sectionData));
    updatedSection.content.splice(index, 1);
    this.sectionValueChangeEmitter.emit(updatedSection);
  }

  changeContentElementSequence(sectionData: any, from: number, to: number) {
    let cutOut = sectionData.content.splice(from, 1) [0];
    sectionData.content.splice(to, 0, cutOut);
    this.sectionValueChangeEmitter.emit(sectionData);
  }

  onLayoutValueChange(event) {
    const contentIndexNeedToChanged = this.sectionData.content.findIndex((content) => content.uuid === event.contentUuid);
    const layoutIndexNeedsToBeChanged = this.sectionData.content[contentIndexNeedToChanged].layout.findIndex(layout => layout.uuid === event.layout.uuid)
    let updatedSection = JSON.parse(JSON.stringify(this.sectionData));
    updatedSection.content[contentIndexNeedToChanged].layout[layoutIndexNeedsToBeChanged] = {
      ...event.layout,
      width: updatedSection.content[contentIndexNeedToChanged].layout[layoutIndexNeedsToBeChanged].width
    }
    this.sectionValueChangeEmitter.emit(updatedSection)
  }

  getLayoutType(contentType: any) {
    if (contentType.layout[0].width === 100 && contentType.layout.length === 1) {
      return this.layoutType['1']
    } else if (contentType.layout[0].width === 50 && contentType.layout.length === 2) {
      return this.layoutType['2']
    } else if (contentType.layout[0].width === 33 && contentType.layout.length === 3) {
      return this.layoutType['3']
    } else if (contentType.layout[0].width === 30 && contentType.layout.length === 2) {
      return this.layoutType['4']
    } else {
      return this.layoutType['5']
    }

  }

  trackByContent(index: number, content: any): string {
    return content.uuid || index.toString();
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}

